import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://vpvsqhnenqfiypzcxaiq.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZwdnNxaG5lbnFmaXlwemN4YWlxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU5NzA5NTQsImV4cCI6MjA3MTU0Njk1NH0.S48jhT0qR0kF9gGA9G-GV8hyR9GwOORV3Gs-inuS4e0'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables')
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'Content-Type': 'application/json'
    }
  }
})

export default supabase